import { z } from 'zod';
const sortColumnOptions = ['NAME', 'DISPLAY_ORDER'] as const;
export const searchSchema = z.object({
  freeText: z.string().default(''),
  showDisabled: z.boolean().default(false),
  categoryId: z.string().optional(),
  sortColumn: z.enum(sortColumnOptions).default('DISPLAY_ORDER'),
  sortOrder: z.enum(['ASC', 'DESC']).default('ASC')
});